module.exports = __webpack_public_path__ + "assets/img/7d20b100df2224adcb294be883fb7f89.svg";